import { FetchResforByNifCommand } from './FetchResforByNifCommand'
import { ResforDataDto } from './ResforDataDto'
import { ResforNif } from '@/Domain/Resfor'
import { ResforRepository } from '@/Domain/Resfor/ResforRepository'

export class FetchResforByNifCommandHandler {
  private _resforRepository: ResforRepository

  constructor (resforRepository: ResforRepository) {
    this._resforRepository = resforRepository
  }

  async handle (command: FetchResforByNifCommand): Promise<ResforDataDto> {
    try {
      const resforNif = new ResforNif(command.resforId())
      const response = await this._resforRepository.byNif(resforNif)
      return ResforDataDto.fromResforData(response)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
